import styled from 'styled-components';

import Modal from 'components/molecules/Modal';
import IcArrowDown from 'utils/assetFiles/svgs/IcArrowDown';
import IcArrowUp from 'utils/assetFiles/svgs/IcArrowUp';
import { AVATAR_COLOR_OPTIONS } from 'utils/constants';

export const ModalInnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
`;

export const SubtitleP = styled.p`
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 8px;
`;

export const TitleContainer = styled.div`
    width: 100%;
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.2px;
    color: rgba(0, 0, 0, 0.87);
    padding-right: 20px;
    padding-left: 20px;
`;

export const ModalWithStyles = styled(Modal)`
    & .ant-modal-header {
        border: 0px;
    }

    & .ant-modal-footer {
        border: 0px;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 5px;
    }

    & .ant-select-selection {
        box-shadow: 0;
    }

    & .ant-modal-content {
        border-radius: 12px;
        padding-top: 20px;
        padding-bottom: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 24px;
`;

export const InputOuterContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin-bottom: 8px;

    &:focus-within {
        color: #6347ff;
        & p {
            color: #6347ff;
        }
    }
`;

export const DropDownWrapperActive = styled.div`
    width: 100px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #d7d5d5;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: 5px;
    padding-right: 5px;
    position: relative;
`;

export const InputContainer = styled.div`
    position: relative;
    width: 100%;
`;

export const AccountInput = styled.input`
    border: ${(props) => (props.showMenu ? '1px solid #4136c0' : '1px solid rgba(0, 0, 0, 0.24)')};
    border-radius: 6px;
    width: 100%;
    height: 40px;
    font-size: 13px;
    padding-left: 15px;
    padding-right: 35px;

    &:disabled {
        background-color: white;
    }

    &:focus {
        outline: none;
        border: 1px solid #4136c0;
    }

    &:hover {
        outline: none;
        border: 1px solid #4136c0;
    }
`;

export const InnerTopConatiner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const InnerBottomContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;

    ${(props) => (props.hasFile ? '& * { opacity: 0.5; cursor: not-allowed;}' : '')};
`;

export const Subtitle = styled.p`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.1px;
    color: rgba(0, 0, 0, 0.87);
`;

export const ProfilePictureContainer = styled.div`
    border-radius: 50%;
    width: 35px;
    height: 35px;

    &:hover {
        cursor: pointer;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.55), 0px 0px 25px rgba(0, 0, 0, 0.35);
    }
`;
export const ProfilePicture = styled.div`
    padding-top: 1px;
    padding-left: 1.25px;
    text-align: center;
    line-height: 35px;
    letter-spacing: 1.25px;
    text-transform: uppercase;
    font-size: 14px;
`;

export const ProfileContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto auto auto auto auto auto auto auto;
    grid-gap: 12px;
    margin-top: 8px;
    padding-left: 15px;
    padding-right: 15px;
`;

export const ProfileBottomContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
`;

export const profileBgColors = AVATAR_COLOR_OPTIONS.map((x) => x.bgColor);

export const profileTextColors = AVATAR_COLOR_OPTIONS.map((x) => x.textColor);

export const ProfileSetUpButtonDiv = styled.div`
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    width: 96px;
    height: 40px;
    color: white;
    letter-spacing: 1.25px;
    background-color: ${(props) => (props.haveChange ? '#6347FF' : '#D3CCFF')};
    text-align: center;
    line-height: 40px;

    &:hover {
        background-color: ${(props) => (props.haveChange ? '#7f68ff' : '#D3CCFF')};
        cursor: pointer;
    }
`;

export const ModalFooterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding-top: 10px;
`;

export const ModalFooterBackContainer = styled.div`
    float: left;
    width: 65px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    & svg path {
        fill: rgba(0, 0, 0, 0.6);
    }

    &:hover {
        cursor: pointer;
        & svg path {
            fill: rgba(0, 0, 0, 0.86);
        }

        & span {
            color: rgba(0, 0, 0, 0.86);
        }
    }
`;

export const ModalFooterBackText = styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 40px;
    letter-spacing: 1.25px;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.6);
    margin-top: 3px;
`;

export const ArrowUpIcon = styled(IcArrowUp)`
    display: flex;
    margin-left: 4px;
`;

export const ArrowDownIcon = styled(IcArrowDown)`
    display: flex;
    margin-left: 4px;
`;

export const SelectedProfileBorder = styled.div`
    border-radius: 50%;
    width: 43px;
    height: 43px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${(props) => (props.selectedBgProfile ? 'border: 2px solid #00154B; padding: 1px;' : '')}
`;

export const SkipButton = styled.div`
    margin-right: 24px;
    letter-spacing: 1.25px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);

    &:hover {
        cursor: pointer;
        color: rgba(0, 0, 0, 0.87);
    }
`;

export const PhotoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .image-loading {
        color: #757575;
    }

    & div img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }

    & p {
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 1.25px;
        color: #6347ff;
        margin-top: 18px;
    }

    & p:not(.image-loading):hover {
        cursor: pointer;
    }
`;
